import {
  redemptionTypeField,
  redemptionLimitField,
  isMultiItemsField,
  PriceField,
  VoucherField,
  DiscountInputTypeField,
  DiscountPercentField,
  DiscountPriceField,
  TitleField,
  DescriptionField,
  LocationsField,
  offerDurationField,
  isTranchesField,
  tranchesField,
  daySelectionField,
  termsAndConditionsField,
  RangeDatePicker,
  estimatedSavingsField,
  estimatedSavingsNoteField,
  TagsField,
} from '../form-and-fields'

import { OFFERTYPE } from '../../MerchantSubscription/types'

type RewardSchema = {
  [offerTypeId: number]: {
    details_and_pricing: IFormField[]
    description: IFormField[]
    terms_and_conditions: IFormField[]
    branch: IFormField[]
  }
}

export const FORM_CONFIGURATION: RewardSchema = {
  [OFFERTYPE.DISCOUNT]: {
    details_and_pricing: [
      offerDurationField,
      RangeDatePicker,
      redemptionTypeField,
      redemptionLimitField,
      isMultiItemsField,
      PriceField,
      DiscountInputTypeField,
      DiscountPercentField,
      DiscountPriceField,
      estimatedSavingsField,
      estimatedSavingsNoteField,
      daySelectionField,
    ],
    description: [TitleField, DescriptionField, TagsField],
    terms_and_conditions: [termsAndConditionsField],
    branch: [LocationsField],
  },
  [OFFERTYPE.VOUCHER]: {
    details_and_pricing: [
      offerDurationField,
      RangeDatePicker,
      redemptionTypeField,
      redemptionLimitField,
      VoucherField,
      estimatedSavingsField,
      estimatedSavingsNoteField,
      daySelectionField,
    ],
    description: [TitleField, DescriptionField, TagsField],
    terms_and_conditions: [termsAndConditionsField],
    branch: [LocationsField],
  },
  [OFFERTYPE.BUNDLE]: {
    details_and_pricing: [
      offerDurationField,
      RangeDatePicker,
      redemptionTypeField,
      redemptionLimitField,
      PriceField,
      estimatedSavingsField,
      estimatedSavingsNoteField,
      daySelectionField,
    ],
    description: [TitleField, DescriptionField, TagsField],
    terms_and_conditions: [termsAndConditionsField],
    branch: [LocationsField],
  },
  [OFFERTYPE.BUY1_GET1]: {
    details_and_pricing: [
      offerDurationField,
      RangeDatePicker,
      redemptionTypeField,
      redemptionLimitField,
      isTranchesField,
      tranchesField,
      isMultiItemsField,
      PriceField,
      estimatedSavingsField,
      estimatedSavingsNoteField,
      daySelectionField,
    ],
    description: [TitleField, DescriptionField, TagsField],
    terms_and_conditions: [termsAndConditionsField],
    branch: [LocationsField],
  },
}

export const MERCHANT_DOCUMENT_FIELD = {
  crUri: 'crUri',
  licenseUri: 'licenseUri',
  establishmentCardUri: 'establishmentCardUri',
  tradeLicenseUri: 'tradeLicenseUri',
  taxCardUri: 'taxCardUri',
}
